import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchDepositPolicies,
  createDepositPolicy,
  updateDepositPolicy,
  deleteDepositPolicy,
  type ListDepositPoliciesQuery,
  type CreateDepositPolicyPayload,
  type UpdateDepositPolicyPayload,
} from '@/services/api/depositPolicies.api';

export function useDepositPolicies(
  query: ListDepositPoliciesQuery,
  enabled = true,
) {
  return useQuery({
    queryKey: ['deposit-policies', query],
    queryFn: () => fetchDepositPolicies(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useCreateDepositPolicy() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateDepositPolicyPayload) =>
      createDepositPolicy(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['deposit-policies'] });
    },
  });
}

export function useUpdateDepositPolicy() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: UpdateDepositPolicyPayload;
    }) => updateDepositPolicy(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['deposit-policies'] });
    },
  });
}

export function useDeleteDepositPolicy() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteDepositPolicy(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['deposit-policies'] });
    },
  });
}
